// import Swiper from 'swiper';
// import { Navigation, Pagination } from 'swiper/modules';

const sliderCat = () => {
  const sliders = document.querySelectorAll('.slider-cat');
  if (!sliders.length) return;

  sliders.forEach(slider => {
    if (!slider.dataset.slider) return;
    new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 24,
      pagination: {
        el: slider.querySelector('.swiper-pagination'),
        type: 'fraction',
      },
      navigation: {
        nextEl: slider.querySelector('.swiper-button-next'),
        prevEl: slider.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        992: {
          slidesPerView: 3,
        },
      },
    });
  });
};

export default sliderCat;
